module.exports = __webpack_public_path__ + "static/media/OH-second.8ac1b310.svg";